module.exports = __webpack_public_path__ + "img/amx-13.47fb2336.webp";